import React, { CSSProperties, useEffect, useState } from 'react';
import styled from 'styled-components';

import { colors, metrics } from '../assets/styles/commonStyle';

const Wrapper = styled.div`
  display: flex;
`;

export const Tab = styled.div<{ active: boolean }>`
  border: 1px solid ${props => (props.active ? colors.transparent : colors.buttonDefault)};
  background: ${props => (props.active ? colors.buttonDefault : colors.white)};
  padding: ${metrics.padding.base}px ${metrics.padding.extraLarge}px;
  cursor: pointer;
  color: ${props => (props.active ? colors.white : colors.buttonDefault)};
  :nth-child(n + 2) {
    margin-left: -1px;
  }
`;

interface TabProps {
  name: string;
  active: boolean;
  onClick: () => any;
  dataTestId?: string;
}

interface TabsProps {
  style?: CSSProperties;
  tabs: TabProps[];
}

const computeActiveIndex = (tabs: TabProps[] | undefined) =>
  tabs ? tabs.findIndex(tab => tab.active) : 0;

export const Tabs: React.FC<TabsProps> = ({ style, tabs }) => {
  const [activeIndex, setActiveIndex] = useState(() => computeActiveIndex(tabs));

  useEffect(() => {
    setActiveIndex(computeActiveIndex(tabs));
  }, [tabs]);

  const onTabClick = (fn: () => any, index: number) => () => {
    setActiveIndex(index);
    if (typeof fn === 'function') {
      fn();
    }
  };

  return (
    <Wrapper style={style || {}}>
      {tabs.map((item, index) => (
        <Tab
          active={index === activeIndex}
          key={index}
          onClick={onTabClick(item.onClick, index)}
          data-testid={item.dataTestId || `tab_${index}`}
          /* Exposes the selected state to CSS. styled-components filters the `active` prop off the
             DOM node, so a theme cannot otherwise tell the two states apart. Purely additive. */
          data-active={index === activeIndex}
        >
          {item.name.toUpperCase()}
        </Tab>
      ))}
    </Wrapper>
  );
};

export default Tabs;
